import React from 'react';
import { motion } from 'framer-motion';
const fadeIn = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
export function PainSection() {
  return <section className="py-14 px-4 bg-navy-50" data-id="element-194">
      <div className="max-w-3xl mx-auto text-center" data-id="element-195">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={fadeIn} className="space-y-10" data-id="element-196">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-navy-900 leading-tight" data-id="element-197">
            Una mirada más precisa sobre lo que te está frenando
          </h2>

          <div className="space-y-6 text-lg md:text-xl text-navy-700 font-light leading-relaxed" data-id="element-198">
            <p data-id="element-199">A veces no necesitas más información.</p>
            <p data-id="element-200">Ni más motivación.</p>
            <p data-id="element-201">Ni más esfuerzo.</p>
            <p className="text-navy-900 font-medium pt-4" data-id="element-202">
              Necesitas ver con verdad lo que hasta ahora ha operado en
              silencio.
            </p>

            <div className="py-8 space-y-4 text-2xl font-serif text-navy-900 italic" data-id="element-203">
              <p data-id="element-204">La forma en que te relacionas con Dios.</p>
              <p data-id="element-205">La forma en que sostienes o pierdes el dinero.</p>
              <p data-id="element-206">La forma en que te conduces a ti mismo.</p>
            </div>

            <p data-id="element-207">
              Cuando una de esas áreas se hiere, las otras también se
              desordenan.
            </p>
            <p data-id="element-208">
              Por eso muchas personas oran, trabajan, intentan cambiar…
              <br data-id="element-209" />
              <span className="text-navy-900 font-medium" data-id="element-210">
                y aun así siguen en el mismo ciclo.
              </span>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}